import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FlywheelLoader from './flywheel/flywheelloader'
import CloudwaysLoader from './cloudways/cloudwaysloader'
import WPEngineLoader from './wpengine/wpengineloader'
import MgValidating from './mg/mgvalidating'
import WPCOMLoader from './wpcom/wpcomloader'

class Validating extends Component {
	render() {
		const { message, migrate } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelLoader message="Validating Details"/>
			case ORIGIN.CLOUDWAYS:
			return <CloudwaysLoader message="Validating Details"/>
		case ORIGIN.WPENGINE:
			return <WPEngineLoader />
		case ORIGIN.AUTOMATTIC:
			return <WPCOMLoader message="Verifying your information"/>
		default:
			return <MgValidating message={message}/>
		}
	}
}

Validating.propTypes = {
	message: PropTypes.string,
	migrate: ImmutablePropTypes.map
}

export default Validating
